module.exports = __webpack_public_path__ + "static/media/main2.d73caae6.jpg";